<template>
  <div>
    <keep-alive>
      <component :is="coms" :cutcoms="cutcoms" ref="isnowcom"></component>
    </keep-alive>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      isActive: 0,
      rowObj: {}, // 跳转数据
    };
  },
  components: {
    Page: () => import("./page.vue"),
    studentType: () => import("./components/studentType.vue"),
    subjectLibrary: () => import("./components/subjectLibrary.vue"),
    topicList: () => import("./components/topicList.vue"),
  },
  computed: {
    coms() {
      switch (this.isActive) {
        case 0:
          return "Page";
        case 1:
          return "studentType";
        case 2:
          return "subjectLibrary";
        case 3:
          return "topicList";
      }
      return "ss";
    },
  },
  methods: {
    cutcoms(index) {
      this.isActive = index;
    },
  },
  updated() {
    {
      window.scroll(0, 0);
    }
  },
};
</script>
  